/**
 * Nastavení nette.ajax.js a přidání popup rozšíření
 */
export default function () {
	if ($.nette.ext('popup')) {
		//Cannot override already registered nette-ajax extension 'popup'.
		return;
	}

	$.nette.ext('init').linkSelector = 'a.ajax, .remodal a:not(.ajax-off)';
	$.nette.ext('init').formSelector =
		'form.ajax, .remodal form:not(.ajax-off)';
	$.nette.ext('unique', null);
	$.nette.ext(
		'popup',
		{
			init: function () {
				var self = this;

				this.ext('snippets', true).after(
					$.proxy(function ($el) {
						if ($el.is('.remodal')) {
							self.open($el);
						}
					}, this)
				);

				$('.remodal[id^="snippet-"]').each(function () {
					self.open($(this));
				});

				$(document).on('closed', '.remodal', function (e) {
					$(this).removeAttr('style');
				});
			}
		},
		{
			open: function (el) {
				var remodal = el.remodal({
					hashTracking: false
				});

				if (el.find('.content').length) {
					if (remodal.getState() !== 'opened') {
						remodal.open();
					}
					el.find('[autofocus]').focus(); // force autofucus (broken since chrome 79)
				} else if (remodal.getState() === 'opened') {
					remodal.close();
				}
			}
		}
	);
	$.nette.init();

	$('a.no-ajax').netteAjaxOff();
}
